<template>
  <div class="error-container">
    <div class="error-content">
      <h1 class="error-title">404</h1>
      <div class="error-message">抱歉，您访问的页面不存在...</div>
      <div class="error-desc">请检查您输入的网址是否正确，或者点击下面的按钮返回。</div>
      <div class="btn-group">
        <button class="error-btn home-btn" @click="goToHomePage">返回首页</button>
        <button class="error-btn login-btn" @click="goToLoginPage">返回登录页</button>
      </div>
    </div>
  </div>
</template>

<script>
import { getToken, removeToken } from '@/utils/auth'
import store from '@/store'

export default {
  name: 'Page404',
  created() {
    // 检查是否登录，如果未登录则自动跳转到登录页
    if (!getToken()) {
      this.goToLoginPage();
    }
  },
  methods: {
    // 使用原生方式强制跳转到首页
    goToHomePage() {
      // 尝试清除可能导致问题的数据
      this.cleanupBeforeRedirect();
      // 使用原生方式跳转
      const basePath = window.location.origin;
      window.location.href = basePath + '/';
    },
    // 使用原生方式强制跳转到登录页
    goToLoginPage() {
      // 尝试清除可能导致问题的数据
      this.cleanupBeforeRedirect();
      // 使用原生方式跳转
      const basePath = window.location.origin;
      window.location.href = basePath + '/login';
    },
    // 清除可能导致问题的登录状态和缓存
    cleanupBeforeRedirect() {
      // 尝试清除token
      try {
        removeToken();
        localStorage.removeItem('userInfo');
        localStorage.removeItem('permissions');
        sessionStorage.clear();
        
        // 尝试重置store中的状态
        if (store && store.dispatch) {
          store.dispatch('user/resetToken').catch(err => {
            console.error('重置token失败:', err);
          });
        }
      } catch (error) {
        console.error('清除登录状态失败:', error);
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.error-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #f5f7fa;
}

.error-content {
  text-align: center;
  padding: 40px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  max-width: 500px;
}

.error-title {
  font-size: 120px;
  color: #1482f0;
  margin: 0;
  line-height: 1.2;
  text-shadow: 2px 2px 0 #f0f0f0;
}

.error-message {
  font-size: 24px;
  color: #303133;
  margin: 20px 0;
  font-weight: bold;
}

.error-desc {
  font-size: 16px;
  color: #606266;
  margin-bottom: 30px;
}

.btn-group {
  display: flex;
  justify-content: center;
  gap: 20px;
}

.error-btn {
  display: inline-block;
  padding: 10px 30px;
  border-radius: 50px;
  text-decoration: none;
  font-size: 16px;
  transition: background 0.3s;
  border: none;
  cursor: pointer;
}

.home-btn {
  background: #1482f0;
  color: white;
  
  &:hover {
    background: #0d6efd;
  }
}

.login-btn {
  background: #67C23A;
  color: white;
  
  &:hover {
    background: #5daf33;
  }
}
</style>